import { useEffect } from 'react';

import getSelectedElementUuids from 'editor/src/store/editor/selector/getSelectedElementUuids';
import { useSelector } from 'editor/src/store/hooks';

import CustomFabricActiveSelection from 'editor/src/fabric/CustomFabricActiveSelection';
import CustomFabricImage from 'editor/src/fabric/CustomFabricImage';
import CustomFabricObject from 'editor/src/fabric/CustomFabricObject';
import useFabricCanvas from 'editor/src/util/useFabricCanvas';

import { getActiveSelection, getSelectionUuids } from 'editor/src/component/EditorArea/utils/groupSelectionUtils';

import { useDimensionChangeRender } from './useDimensionChangeRender';

// support multiple elements selection through store
function useGroupStoreSelection() {
  const fabricCanvas = useFabricCanvas();
  const groupActiveSelection = getActiveSelection(fabricCanvas);
  const storeSelectedElementUuids = useSelector(getSelectedElementUuids);

  // Track dimension changes to update selection
  useDimensionChangeRender();

  useEffect(() => {
    if (!storeSelectedElementUuids.length && fabricCanvas.getActiveObject()) {
      fabricCanvas.discardActiveObject();
      fabricCanvas.requestRenderAll();
      return;
    }

    const storeElementUids = [...storeSelectedElementUuids].sort();
    const fabricElementUids = getSelectionUuids(fabricCanvas.getActiveObjects() as CustomFabricObject[]);

    if (storeElementUids.toString() !== fabricElementUids.toString()) {
      const newActiveObjects = fabricCanvas.getObjects().filter((fabricObject) => {
        const { uuid } = fabricObject as any;
        return !(fabricObject as CustomFabricImage).groupSelectionDisabled && storeElementUids.includes(uuid);
      });

      fabricCanvas.discardActiveObject();
      if (newActiveObjects.length === 1) {
        fabricCanvas.setActiveObject(newActiveObjects[0]);
      } else if (newActiveObjects.length > 1) {
        fabricCanvas.setActiveObject(new CustomFabricActiveSelection(newActiveObjects, { canvas: fabricCanvas }));
      }
    }
  }, [storeSelectedElementUuids, !!groupActiveSelection]);
}

export default useGroupStoreSelection;
